module.exports = __webpack_public_path__ + "img/Mage-troll-f-60.51fe0c68.gif";